import React from 'react';
import { useSelector } from 'react-redux';
import { Alert } from '@material-ui/lab';
import Box from '@material-ui/core/Box';
import { IdPropType } from '../../../proptypes/basic';
import { selectCustomerById } from '../customersSlice';

/**
 * #1035 roter Hinweis im BK-Verlauf / in den BK-Anfragen (dorthin fuehrt das
 * Einsatz-Dashboard), solange zur Oster- bzw. Weihnachts-/Neujahrsbetreuung
 * noch kein Eintrag gemacht wurde. Zeitraum und Frist aus der Administration,
 * ausgerechnet im Backend (Customer::holidayCareMissing).
 */
const HolidayCareReminder = ({ customerId }) => {
    const customer = useSelector((state) => selectCustomerById(state, customerId));
    const missing = (customer && customer.holidayCareMissing) || [];

    if (missing.length === 0) {
        return null;
    }

    return (
        <>
            {missing.map(({ field, label, deadline }) => (
                <Box mb={1} key={field}>
                    <Alert severity="error" variant="filled">
                        {`Achtung: Noch kein Eintrag zur ${label} getätigt (bis ${deadline})`}
                    </Alert>
                </Box>
            ))}
        </>
    );
};

HolidayCareReminder.propTypes = {
    customerId: IdPropType.isRequired,
};

export default HolidayCareReminder;
